import { useMutation } from '@apollo/client'
import { ResendEmailQuestionnaire, ResendEmailQuestionnaireVariables } from '../../types'
import { RESEND_EMAIL_QUESIONNAIRE } from './operations'

export const useResendEmailQuestionnaire = () =>
  useMutation<ResendEmailQuestionnaire, ResendEmailQuestionnaireVariables>(
    RESEND_EMAIL_QUESIONNAIRE
  )
